import { Action, Subject } from '@erp/authz';
import { useCan } from 'src/hooks/useCan';
import {
  planSendBackToTypeAgent,
  type SendBackPlan,
  type SendBackTaskSnapshot,
  type SendBackTaskTypeSnapshot,
} from './sendBackToAgentPlan';

/**
 * The send-back plan when the caller may update tasks and the task's type
 * names a default agent; null hides the action. Completed tasks are included:
 * reopening clears the recorded outcome. A deleted task cannot be sent back.
 */
export function useSendBackToAgentPlan(
  task: SendBackTaskSnapshot & { deletedAt?: Date | string | null },
  taskType: SendBackTaskTypeSnapshot | null | undefined,
): SendBackPlan | null {
  const [canUpdateTasks] = useCan(Action.Update, Subject.Task);
  if (!canUpdateTasks || task.deletedAt != null) return null;
  return planSendBackToTypeAgent({ task, taskType });
}
